export default __webpack_public_path__ + "static/media/elle12.6efa0b2e.webp";